import axios from 'axios';
import CONFIG from './config';

axios.defaults.baseURL = CONFIG.API_URL;
axios.defaults.timeout = 10000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// axios 拦截器配置
// axios.interceptors.request.use((config) => {
// 	if (config.url === 'isg/token') {
// 		return config;
// 	} else {
// 		let token = localStorage.getItem('token');
// 		config.headers.common['Authorization'] = token;
// 		return config;
// 	}
// });

// 减少一层层级
axios.interceptors.response.use((config) => {
	return config.data;
});

export default axios;
